import { render } from "./NotificationDetails.vue?vue&type=template&id=5cad945e&scoped=true"
import script from "./NotificationDetails.vue?vue&type=script&lang=js"
export * from "./NotificationDetails.vue?vue&type=script&lang=js"

import "./NotificationDetails.vue?vue&type=style&index=0&id=5cad945e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cad945e"]])

export default __exports__